import React, {Component} from 'react';
import {groupObjectsByProp} from 'helpers/array-helper';

class Dashboard extends Component {
    getLineupsQuantity() {
        const {lineups, filterLineupsByPlayer} = this.props;

        if (filterLineupsByPlayer.hasCheckedPlayers()) {
            return filterLineupsByPlayer.getLineupsQuantity();
        }

        return lineups.getQuantity();
    }

    getUsedPlayersQuantity() {
        const {usedPlayers, filterLineupsByPlayer} = this.props;

        if (filterLineupsByPlayer.hasCheckedPlayers()) {
            return filterLineupsByPlayer.getUsedPlayersQuantity();
        }

        return Object.keys(groupObjectsByProp(usedPlayers.getExposedPlayers(), 'playerId')).length;
    }

    getTotalPlayersQuantity() {
        const {usedPlayers, filterLineupsByPlayer} = this.props;

        if (filterLineupsByPlayer.hasCheckedPlayers()) {
            return filterLineupsByPlayer.getUsedPlayersQuantity();
        }

        return Object.keys(groupObjectsByProp(usedPlayers.all(), 'playerId')).length;
    }
}

export {Dashboard};
